<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="petForm" label-width="auto" label-position="right">
      <el-form-item label="宠物类别：">
        <el-select v-model="type" placeholder="Select" class="select-item">
          <el-option v-for="item in petTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品种：">
        <el-input v-model="petForm.name" placeholder="请输入品类名称" />
      </el-form-item>
      <el-form-item label="头像：">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
      <el-form-item label="花色：" v-if="type == 1">
<!--        <el-space wrap style="margin-bottom: 8px;" v-if="idx > -1">-->
<!--          <div v-for="(item,index) of petForm.petBreedArr" :key="item.id">-->
<!--            <el-tag v-if="!item.show" size="large" closable  @click="inputBreed(item)" @close="delBreed(index, item)" class="cursor">{{ item.name }}</el-tag>-->
<!--            <el-input ref="InputRef" v-else type="text" v-model="item.name" style="width: 6em" @blur="breedChange(item)" autofocus/>-->
<!--          </div>-->

<!--          <el-button @click="showAdd = !showAdd"> + 添加品种</el-button>-->
<!--        </el-space>-->
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="newBreedArr" placeholder="输入花色（每行一个）" />
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="petForm.orderNum" placeholder="请输入排序数值" />
      </el-form-item>
      <el-form-item label="置顶：" v-if="type == 2">
        <el-switch
            v-model="isTop"
            active-text="是"
            inactive-text="否"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, getFormData, imgPostFormData} from "@/api/api"
import { addOrUpdatePetBreed, updateOrDelBreed } from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      petForm: this.value.petForm,
      idx: this.value.ids,
      newBreedArr: '',
      // showAdd: this.value.ids <= -1,
      petTypeArray: [
        {label: '猫', value: 1},
        {label: '狗', value: 2}
      ],
      type: this.value.petForm.type?this.value.petForm.type:1,
      isTop: this.value.petForm.isTop?this.value.petForm.isTop:0,
      files: null,
      src: this.value.petForm.headImg,
    }
  },
  methods: {
    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },


    // inputBreed(item) {
    //   this.petForm.petBreedArr.map(item => {
    //     item.show = false
    //   })
    //   item.show = true
    // },
    //
    // breedChange(item) {
    //   let param = {}
    //   param['id'] = item.id;
    //   param['name'] = item.name;
    //   param['type'] = 1;
    //   postFormData(updateOrDelBreed, param).then((data) => {
    //     let {msg, code} = data
    //     if (code == 200) {
    //       this.$message({
    //         showClose: true,
    //         duration: 2000,
    //         message: msg,
    //         type: 'success'
    //       });
    //       item.show = false
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 2000,
    //         message: msg,
    //         type: 'warning'
    //       });
    //     }
    //   })
    // },

    summit() {
      // console.log(this.idx)
      if(!this.petForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '品种名称不能为空',
          type: 'warning'
        });
        return false
      }
      // if(!this.src) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '头像不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      if(!this.newBreedArr && this.idx == -1 && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '花色不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.petForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      // let param = {}
      // param['id'] = this.idx > -1?this.petForm.id:0;
      // param['name'] = this.petForm.name;
      // param['orderNum'] = this.petForm.orderNum;
      // if(this.newBreedArr) {
      //   param['petBreedColorArr'] = this.newBreedArr.split('\n');
      // }
      let param = new FormData();
      param.append('id', this.idx > -1?this.petForm.id:0);
      param.append('name', this.petForm.name);
      param.append('orderNum', this.petForm.orderNum);
      param.append('file', this.files);
      param.append('type', this.type);
      param.append('isTop', this.isTop);
      if(this.newBreedArr) {
        param.append('petBreedColorArr', this.newBreedArr.split('\n'));
      }
      imgPostFormData(addOrUpdatePetBreed, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    // delBreed(idx, item) {
    //   this.$confirm('确认删除品种【' + item.name + '】？').then(() => {
    //     let param = {}
    //     param['id'] = item.id;
    //     param['name'] = item.name;
    //     param['type'] = 2;
    //     postFormData(updateOrDelBreed, param).then((data) => {
    //       let {msg, code} = data
    //       if (code == 200) {
    //         this.$message({
    //           showClose: true,
    //           duration: 2000,
    //           message: msg,
    //           type: 'success'
    //         });
    //         this.petForm.petBreedArr.splice(idx, 1)
    //       }else {
    //         this.$message({
    //           showClose: true,
    //           duration: 2000,
    //           message: msg,
    //           type: 'warning'
    //         });
    //       }
    //     })
    //   })
    //
    // }


  },
  mounted() {
    // if(this.idx > -1) {
    //   this.petForm.petBreedArr.forEach(item => {
    //     item.show = false
    //   })
    // }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
